import { render, staticRenderFns } from "./UyapEvrakGonderForm.vue?vue&type=template&id=e89dc824"
import script from "./UyapEvrakGonderForm.vue?vue&type=script&lang=ts"
export * from "./UyapEvrakGonderForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports